export default {
  methods: {
    filterByWeight() {},
  },
};
